import moment from 'moment';
import { bespokeTenants } from '../index.js';
/**
 * The two ledgers APCOA runs the parking business through. Parking, fee and DMR
 * data lives in the APCOA company; the debt collection case archive lives in
 * the EuroIncasso one.
 *
 * Each ERP names them differently -- NAV called them `EuroPark A/S` and
 * `EuroIncasso ApS`, Business Central calls them `APCOA Danmark` and
 * `Euroincasso` -- so callers pick a company by this enum and the provider
 * module resolves the name or id the backend expects.
 */
export var ApcoaCompany;
(function (ApcoaCompany) {
    ApcoaCompany["Apcoa"] = "APCOA";
    ApcoaCompany["EuroIncasso"] = "EUROINCASSO";
})(ApcoaCompany || (ApcoaCompany = {}));
export const APCOA_TENANT_IDS = [
    bespokeTenants.apcoaProd,
    bespokeTenants.apcoaSandbox,
];
export const EUROINCASSO_TENANT_IDS = [
    bespokeTenants.euroIncassoProd,
    bespokeTenants.euroIncassoSandbox,
];
export const APCOA_EI_TENANT_IDS = [
    ...APCOA_TENANT_IDS,
    ...EUROINCASSO_TENANT_IDS,
];
export const APCOA_AUTOMATSAG = process.env.NODE_ENV === 'production'
    ? 'ce15e0a1-ea8e-46c1-ab42-9e46004edf42'
    : '9a5122eb-7654-4d89-9fa5-070d4867e3dc';
export const getUserFromDMR = (dmr) => {
    const cvr = dmr.User_VAT_Registration_No?.trim() === 'null'
        ? null
        : dmr.User_VAT_Registration_No?.trim() || null;
    return {
        address: getUserAddressFromDMR(dmr),
        isCompany: getUserIsCompanyFromDMR(dmr),
        birthdate: moment(dmr.User_Birth_Date, 'YYYY-MM-DD').toISOString(),
        description: 'Bruger fra DMR',
        name: dmr.User_Name,
        cvr,
    };
};
export const getUserAddressFromDMR = (dmr) => {
    if (!dmr.User_Address?.trim()) {
        return null;
    }
    return {
        address: dmr.User_Address,
        coAddress: dmr.User_Address_2,
        zipcode: dmr.User_Post_Code,
        city: dmr.User_City,
        country: dmr.User_Country_Code || 'Danmark',
    };
};
export const getUserIsCompanyFromDMR = (dmr) => {
    return dmr.User_Type !== 'Privat';
};
export const getOwnerFromDMR = (dmr) => {
    return {
        address: getOwnerAddressFromDMR(dmr),
        isCompany: getOwnerIsCompanyFromDMR(dmr),
        birthdate: moment(dmr.Owner_Birth_Date, 'YYYY-MM-DD').toISOString(),
        description: 'Ejer',
        name: dmr.Owner_Name,
        cvr: dmr.Owner_VAT_Registration_No || null,
    };
};
export const getOwnerAddressFromDMR = (dmr) => {
    return {
        address: dmr.Owner_Address,
        coAddress: dmr.Owner_Address_2,
        zipcode: dmr.Owner_Post_Code,
        city: dmr.Owner_City,
        country: dmr.Owner_Country_Code || 'Danmark',
    };
};
export const getOwnerIsCompanyFromDMR = (dmr) => {
    return dmr.Owner_Type !== 'Privat';
};
export const discountedCarRentalCompaniesCVR = [
    '26045215', //SHARED MOBILITY A/S
    '27972721', //MOBILITY SERVICE DANMARK A/S
    '19986292', //Europcar Mobility Group Denmark A/S
    '30709594', //VIA BILER UDLEJNING A/S
];
// The parsed objects are whatever the stream carries: NAV and Debbie's own API
// stream FeeImage rows, while Business Central streams raw rows that still
// need mapping — hence the index signature alongside the FeeImage shape.
export const feeImageStreamParser = (state, str) => {
    if (state.state === 'initial') {
        let arrStart = str.indexOf('[');
        if (arrStart != -1) {
            return [{ state: 'in_array' }, str.slice(arrStart + 1), undefined];
        }
    }
    else if (state.state === 'in_array') {
        let arrEnd = str.indexOf(']');
        let objectStart = str.indexOf('{');
        if (arrEnd != -1 && objectStart != -1) {
            if (objectStart < arrEnd) {
                return [
                    { state: 'in_object', content: '' },
                    str.slice(objectStart),
                    undefined,
                ];
            }
            else {
                // There is only one array
                return [{ state: 'initial' }, '', undefined];
            }
        }
        if (arrEnd != -1) {
            return [{ state: 'initial' }, '', undefined];
        }
        if (objectStart != -1) {
            return [
                { state: 'in_object', content: '' },
                str.slice(objectStart),
                undefined,
            ];
        }
    }
    else if (state.state === 'in_object') {
        const objectEnd = str.indexOf('}');
        if (objectEnd != -1) {
            // TODO: Add to object list
            const objStr = state.content + str.slice(0, objectEnd + 1);
            return [
                { state: 'in_array' },
                str.slice(objectEnd + 1),
                JSON.parse(objStr),
            ];
        }
        else {
            return [{ ...state, content: state.content + str }, '', undefined];
        }
    }
    return [state, '', undefined];
};
//# sourceMappingURL=index.js.map